export const CHANGE_LOG = [
    {
        frontend: "2.0.17",
        backend: "1.5.14",
        date: "2026-11-02",
        title: "Tenant provisioning and settings",
        changes: [
            "Nominated students get an award icon next to their name when they have a nomination.",
            "Modules added or removed from tenants are removed completely or added with defaults."
        ]
    },{
        frontend: "2.0.16",
        backend: "1.5.13",
        date: "2026-11-01",
        title: "Achievement Ceremonies and nominations",
        changes: [
            "Each ceremony now has its own page showing every award's nominations, grouped by year level.",
            "Staff can now save nominations, with an optional reason for each student, while nominations are open.",
            "Admins can shortlist, decline or choose a winner for each award and year level.",
            "The dashboard now shows a card for each active ceremony, with a countdown, how many winners have been chosen and what still needs doing.",
            "Click a ceremony's name on the dashboard to open its details.",
            "Awards linked to a ceremony are now saved correctly.",
            "Verification emails now show the VeriSafe logo.",
            "Security updates to the email and server components, and quieter server logs."
        ]
    },{
        frontend: "2.0.15",
        backend: "1.5.12",
        date: "2026-10-29",
        title: "GovFiles improvements",
        changes: [
            "Tidy up code - remove old commented out blocks",
            "Improve email service ",
            "Improve controllers",
            "Prevent sql code from being executed (security risk) - only upload csv"
        ]
    },{
        frontend: "2.0.14",
        backend: "1.5.11",
        date: "2026-06-09",
        title: "Dashboard and GovFiles improvements",
        changes: [
            "Added 'stale' records to the dashboard (WWCC records that have not been checked against the government database for more than 14 days).",
            "Added an 'execute SQL' button to the GovFiles page, which allows superusers to directly execute the generated SQL update script from the 'process response' step. This is intended to streamline the workflow for applying government status updates to WWCC records."
        ]
    },{
        frontend: "2.0.13",
        backend: "1.5.10",
        date: "2026-05-26",
        title: "User email validation",
        changes: [
            "Invalidated email address when a user changes/removes their email."
        ]
    },{
        frontend: "2.0.12",
        backend: "1.5.9",
        date: "2026-05-23",
        title: "Gov files and column sorting",
        changes: [
            "Added a section for superusers to be able to download the WWCC data in a format suitable for government validation.",
            "Implemented sorting on any of the columns on the WWCC page.",
            "Added a tooltip on the status chip to show when a record was last checked and the last government status message.",
            "Added a notes field to a WWCC record."
        ]
    },{
        frontend: "2.0.11",
        backend: "1.5.8",
        date: "2026-05-21",
        title: "Dashboard improvements",
        changes: [
            "Brought the dashboard up to date.",
            "Added a sorting feature to the columns on the WWCC page.",
            "Sorting logic now always places deactivated WWCC records at the bottom of the list."
        ]
    },{
        frontend: "2.0.9",
        backend: "no change",
        date: "2026-05-08",
        title: "Audit Log improvements",
        changes: [
            "Added an H1 tag for SEO purposes",
            "Visual improvements on the Audit Log page, and now searchable.",
        ]
    },{
        frontend: "2.0.8",
        backend: "1.5.7",
        date: "2026-05-06",
        title: "Force password change",
        changes: [
            "Welcome email now sent when tenant is created",
            "Welcome email contains login credentials for the new user",
            "New user is forced to change their own password on first login",
            "Add audit logs for user: create, update, deactivate, reactivate and hard delete",
            "Add audit logs for tenants: create and update"
        ]
    },{
        frontend: "2.0.7",
        backend: "1.5.6",
        date: "2026-05-05",
        title: "Welcome email",
        changes: [
            "Implemented a 'welcome email' that can be sent by super-users"
        ]
    },
    {
        frontend: "2.0.6",
        backend: "1.5.5",
        date: "2026-05-04",
        title: "WWCC tenant limit",
        changes: [
            "Added a WWCC limit per tenant",
            "Implemented an audit log for super-users"
        ]
    },
    {
        frontend: "2.0.5",
        backend: "1.5.4",
        date: "2026-04-30",
        title: "Public submission link & server task",
        changes: [
            "Gave the 'Public submission' page a VeriSafe logo, a better description and basic data validation",
            "Implemented a daily maintenance task to expire WWCC records if expiry_date < TODAY",
        ]
    },
    {
        frontend: "2.0.4",
        backend: "1.5.3",
        date: "2026-04-23",
        title: "Email Security & Automated Reporting",
        changes: [
            "Implemented 6-digit email validation for admin users",
            "Added security check to prevent automated reports from sending to unverified email addresses",
        ]
    },
    {
        frontend: "2.0.3",
        backend: "1.5.2",
        date: "2026-04-21",
        title: "Tenants and exports",
        changes: [
            "Make provision for specifying admin credentials when provisioning a new tenant",
            "Show organisation name on dashboard page",
            "Fixed the error when changing a tenant name",
            "CSV export of WWCC data now shows the correct STATUS field",
            "Implemented a password suggestion helper function"
        ]
    },
    {
        frontend: "2.0.2",
        backend: "1.5.1",
        date: "2026-04-14",
        title: "Audit log",
        changes: [
            "Implemented an audit log",
            "Allowed superusers to hard-delete wwcc and user records"
        ]
    },
    {
        frontend: "2.0.1",
        backend: "1.5.0",
        date: "2026-03-25",
        title: "Logo placement & public wwcc",
        changes: [
            "Resized the logo, which needed placement adjustment",
            "Fixed the WWCC public submission page",
            "Adjusted the minimum width of dashboard cards"
        ]
    }, {
        frontend: "2.0.0",
        backend: "1.4.0",
        date: "2026-03-24",
        title: "SSL authentication",
        changes: [
            "Implemented SSL auth on the server",
            "Deleted WWCC records should not be part of the dashboard count",
            "Migrated staff hook to axios",
            "A superuser now has the ability to add a user to a specific organisation/tenant",
            "Fixed the external WWCC submission link (recaptcha)",
            "Logo update"
        ]
    },
    {
        frontend: "1.2.0",
        backend: "1.3.0",
        date: "2026-03-24",
        title: "Frontend polishing",
        changes: [
            "Heading change on login page",
            "Fixed 'cannot save user' and password requirements"
        ]
    },
    {
        frontend: "1.1.0",
        backend: "1.2.0",
        date: "2026-03-23",
        title: "CI/CD & Versioning Update",
        changes: [
            "Automated deployment via GitHub Actions",
            "Added version indicator to NavMenu",
            "Added email functionality to the backend",
            "Fixed CORS policy for AWS public IP & new domain"
        ]
    },
    {
        frontend: "1.0.0",
        backend: "1.0.0",
        date: "2026-03-15",
        title: "Initial Production Launch",
        changes: [
            "Core Multi-Tenant architecture implemented",
            "WWCC and Achievement Ceremonies modules live",
            "User authentication and role-based access control"
        ]
    }
];